/**
 *  This class takes a MutualLoginRequest and returns a response from the
 *  MutualLoginDAO
 */

import MutualLoginRequest from '../request/MutualLoginRequest';
import MutualLoginResult from '../result/MutualLoginResult';
import MutualLoginDAO from '../dao/MutualLoginDAO';

class MutualLoginService {
	static async getMutualLoginService(request: MutualLoginRequest): Promise<MutualLoginResult> {
		return await MutualLoginDAO.loginUser(request);
	}
}

export default MutualLoginService;
